// This file is auto-generated by dibs-icons script
import { type FC } from 'react';
import Filter20 from './Filter20.tsx';
import Filter24 from './Filter24.tsx';
import Filter40 from './Filter40.tsx';
import Filter48 from './Filter48.tsx';

type FilterProps = {
    variation: '20' | '24' | '40' | '48';
    dataTn?: string;
    role?: 'img';
    ariaLabel?: string;
    ariaLabelledby?: string;
};

const svgVariations = {
    Filter20,
    Filter24,
    Filter40,
    Filter48,
};

const Filter: FC<FilterProps> = ({ variation, ...props }) => {
    const variationKey = `Filter${variation}` as keyof typeof svgVariations;
    const Icon = svgVariations[variationKey];

    if (!Icon) {
        // eslint-disable-next-line no-console
        console.error(`"Filter" icon variation ${variationKey} does not exist`);
        return null;
    }

    return <Icon {...props} />;
};

export default Filter;
